import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AddFavoritePlacesComponent } from 'src/app/shared/add-favorite-places/add-favorite-places.component';

@Component({
  selector: 'app-add-favorites-modal',
  templateUrl: './add-favorites-modal.component.html',
  styleUrls: ['./add-favorites-modal.component.scss'],
})
export class AddFavoritesModalComponent implements OnInit {
  @ViewChild(AddFavoritePlacesComponent, { static: false }) addFavoritePlacesComponent!: AddFavoritePlacesComponent;
  constructor(private modalController: ModalController) { }

  ngOnInit() {}

  dismissModal() {
    return this.modalController.dismiss('close');
  }
}
